import { StandardComp } from "../atoms/standardComp"
import { icon } from "../functions/icons"

export const ReviewMultipleChoiceOptios = ({ exercise }) => {
    return (
        <StandardComp editClass="quiz-block-preview not-clickable" style={{ "width": "100%" }} content={<>
            <h6 className="standard-small-margin-bottom standard-text-color">{exercise.quiz_question} <span style={{ "color": "var(--standard-text-color-light)", "fontWeight": "normal", "fontSize": "0.75rem" }}>({exercise.earnedPoints}/{exercise.possiblePoints}p)</span></h6>
            {exercise.assessments_answer_content.map((answer, idx) => (
                <div key={idx}>
                    <StandardComp editClass={`quiz-answer-preview  standard-text-color ${(!answer.quiz_correct_answer && answer.chosen) && "quiz-answer-incorrect"} ${answer.quiz_correct_answer && answer.chosen && "quiz-answer-correct"} ${answer.quiz_correct_answer && !answer?.chosen && "quiz-answer-correct"}`} content={
                        <>
                            {answer.quiz_correct_answer == true && answer.chosen == true && <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 24)}</span>} {(answer.quiz_correct_answer && !answer.chosen) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>}  {(!answer.quiz_correct_answer && answer.chosen) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>} {answer.quiz_answer} <span style={{fontSize:"0.7rem", marginLeft:"1rem"}}>{answer?.chosen ? "( Jouw antwoord )":answer.quiz_correct_answer && " (Het juiste antwoord)"}</span>
                        </>
                    } />
                </div>
            ))}
        </>}>
            {/* <Alert title="Feedback" message={exercise.feedback} type="info" /> */}
        </StandardComp>
    )
}

export const ReviewImageOptions = ({ exercise }) => {
    return(
    <StandardComp editClass="quiz-block-preview not-clickable" style={{ "width": "100%" }} content={<>
        <h6 className="standard-small-margin-bottom standard-text-color">{exercise?.quiz_question} <span style={{ "color": "var(--standard-text-color-light)", "fontWeight": "normal", "fontSize": "0.75rem" }}>({exercise.earnedPoints}/{exercise.possiblePoints}p)</span></h6>
        <div className="photo-options-quiz-grid" style={{}}>
            {exercise.assessments_answer_content.map((answer, idx) => (
  
                    <StandardComp editClass={`quiz-answer-preview standard-text-color ${(!answer.quiz_correct_answer && answer.chosen) && "quiz-answer-incorrect"} ${answer.quiz_correct_answer && "quiz-answer-correct"}`} content={
                        <>
                            {/* {answer.quiz_correct_answer && <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 24)}</span>} {(!answer.quiz_correct_answer && answer.chosen) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>} */}
                            <img style={{width:"100%", objectFit:"cover", borderRadius:"0.5rem", height:"100%"}} src={answer.quiz_answer.image.url}/>
                        </>
                    } />
     
            ))}
        </div>
    </>}>
        {/* <Alert title="Feedback" message={exercise.feedback} type="info" /> */}
    </StandardComp>)
}
export const ReviewOrderOptions = ({ exercise }) => {
    return(
    <StandardComp editClass="quiz-block-preview not-clickable" style={{ "width": "100%" }} content={<>
        <h6 className="standard-small-margin-bottom standard-text-color">Zet in de juiste volgorde <span style={{ "color": "var(--standard-text-color-light)", "fontWeight": "normal", "fontSize": "0.75rem" }}>({exercise.earnedPoints}/{exercise.possiblePoints}p)</span></h6>
        {exercise.assessments_answer_content.map((answer, idx) => (
            <div key={idx}>
                <StandardComp editClass={`quiz-answer-preview standard-text-color ${((!answer.chosen && !answer.quiz_correct_answer && answer.text)) && "quiz-answer-incorrect"} ${answer.text && "quiz-answer-correct"}`} content={
                    <>
                        {answer.text && answer.chosen && answer.quiz_correct_answer && <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 24)}</span>} {(!answer.chosen && !answer.quiz_correct_answer && answer.text) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>} {answer.text}
                    </>
                } />
            </div>
        ))}
    </>}>
        {/* <Alert title="Feedback" message={exercise.feedback} type="info" /> */}
    </StandardComp>)
}
export const ReviewMatchOptions = ({ exercise }) => {
    console.log(exercise)
    return(
    <StandardComp editClass="quiz-block-preview not-clickable" style={{ "width": "100%" }} content={<>
        <h6 className="standard-small-margin-bottom  standard-text-color">Match de volgende onderdelen bij elkaar<span style={{ "color": "var(--standard-text-color-light)", "fontWeight": "normal", "fontSize": "0.75rem" }}>({exercise.earnedPoints}/{exercise.possiblePoints}p)</span></h6>
        <div className="grid-2-overview">
        {exercise.assessments_answer_content.map((answer, idx) => (
 <>
                <StandardComp editClass={`quiz-answer-preview standard-text-color ${(!answer.quiz_correct_answer && answer.chosen) && "quiz-answer-incorrect"} ${answer.quiz_correct_answer && "quiz-answer-correct"}`} content={
                    <>
                        {answer.quiz_correct_answer && <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 24)}</span>} {(!answer.quiz_correct_answer && answer.chosen) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>} {answer.answer}
                       
                    </>
                } />
                <StandardComp editClass={`quiz-answer-preview standard-text-color ${(!answer.quiz_correct_answer && answer.chosen) && "quiz-answer-incorrect"} ${answer.quiz_correct_answer && "quiz-answer-correct"}`} content={
                    <>
                        {answer.quiz_correct_answer && <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 24)}</span>} {(!answer.quiz_correct_answer && answer.chosen) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>} {answer.option}
                       
                    </>
                } />
     </>
        ))}
        </div>
    </>}>
        {/* <Alert title="Feedback" message={exercise.feedback} type="info" /> */}
    </StandardComp>)
}
export const ReviewTrueFalseOptions = ({ exercise }) => {
    return(
    <StandardComp editClass="quiz-block-preview not-clickable" style={{ "width": "100%" }} content={<>
        <h6 className="standard-small-margin-bottom standard-text-color">{exercise.quiz_question} <span style={{ "color": "var(--standard-text-color-light)", "fontWeight": "normal", "fontSize": "0.75rem" }}>({exercise.earnedPoints}/{exercise.possiblePoints}p)</span></h6>
        
        {exercise.assessments_answer_content.map((answer, idx) => (
            <div key={idx}>
                <StandardComp editClass={`quiz-answer-preview standard-text-color ${(!answer.quiz_correct_answer && answer?.chosen) && "quiz-answer-incorrect"} ${answer.chosen && answer.quiz_correct_answer && "quiz-answer-correct"} ${!answer?.chosen && answer.quiz_correct_answer && "quiz-answer-incorrect"}`} content={
                    <>
                        {(answer.chosen && answer.quiz_correct_answer)  ? <span style={{ "color": "var(--success-600)" }}>{icon("check-circle", 24)}</span>:<></>} {(answer?.chosen && !answer.quiz_correct_answer) && <span style={{ "color": "var(--error-600)" }}>{icon("x-circle", 24)}</span>} {answer.quiz_answer == 1 ? "Waar" : "Niet waar"}
                    </>
                } />
            </div>
        ))}
    </>}>
        {/* <Alert title="Feedback" message={exercise.feedback} type="info" /> */}
    </StandardComp>)
}
export const ReviewOpenOptions = ({ exercise }) => {
    return(
    <StandardComp editClass="quiz-block-preview not-clickable" style={{ "width": "100%" }} content={<>
        <h6 className="standard-small-margin-bottom  standard-text-color">{exercise.quiz_question} <span style={{ "color": "var(--standard-text-color-light)", "fontWeight": "normal", "fontSize": "0.75rem" }}>({exercise.earnedPoints}/{exercise.possiblePoints}p)</span></h6>
        <p className="normal-text-dark">{exercise?.assessments_answer_content?.quiz_answer} </p>
    </>}>
        {/* <Alert title="Feedback" message={exercise.feedback} type="info" /> */}
    </StandardComp>)
}